import '../../assets/styles/playground.scss';

import IconMini1 from '../../assets/images/new_main/icon-main-mini-1.png';
import IconMini2 from '../../assets/images/new_main/icon-main-mini-2.png';
import IconMini3 from '../../assets/images/new_main/icon-main-mini-3.png';
import IconMini4 from '../../assets/images/new_main/icon-main-mini-4.png';
import IconMini5 from '../../assets/images/new_main/icon-main-mini-5.png';
import IconMini6 from '../../assets/images/new_main/icon-main-mini-6.png';
import CatEmpty from '../../assets/images/new_main/cat-main-empty.png';
import Cat1 from '../../assets/images/new_main/cat-main-1.png';
import Cat2 from '../../assets/images/new_main/cat-main-2.png';
import Cat3 from '../../assets/images/new_main/cat-main-3.png';
import Cat4 from '../../assets/images/new_main/cat-main-4.png';
import IconSnack from '../../assets/images/new_main/icon-snak.png';
import IconSnackArrow from '../../assets/images/new_main/icon-snack-arrow.png';
import IconSnackBtn from '../../assets/images/new_main/icon-snack-btn.png';

//
import ArrowRightBanner from '../../assets/images/new_main/arrow-right.png';
import PointImg from '../../assets/images/img_point.png';
import BenefitsCatImg from '../../assets/images/benefits_banner.png';
// import CoffeeImg from "../../assets/images/coffee.png";
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow_right.svg';
import EggIcon from '../../assets/icons/main-egg-icon.png';
import AttendanceIcon from '../../assets/icons/main-attendance-icon.png';
import LuckySpinIcon from '../../assets/icons/main-lockyspin-icon.png';
import QuizIcon from '../../assets/icons/main-quiz-icon.png';
import ClickIcon from '../../assets/icons/main-click-icon.png';
import SummonIcon from '../../assets/icons/main-summon-icon.png';
import ShoppingIcon from '../../assets/icons/main-shopping-icon.png';
import { ReactComponent as AppleStoreLogo } from '../../assets/images/apple_store.svg';
import { ReactComponent as GooglePlayLogo } from '../../assets/images/google_play.svg';
import AppStorePopup from '../../assets/images/appstore_popup.png';
import ClosePopup from '../../assets/images/cross_white.svg';

import Button from '../../components/common/Button';
import { useNavigate } from 'react-router';
import { useEffect, useState, useContext } from 'react';
import ModalDialog, { AlertDialog } from '../../components/common/Modal';
import { TextField } from '../../components/common/Input';
import ToastAlert from '../../components/common/Toast';
import React from 'react';
import { useScript, useRunTimeEnvironment } from '../../utils/hooks';
// import summonFriends from "../../services/summoner";
import { AuthContext } from '../../context/AuthContext';
import useSWR from 'swr';
import { getPaidToWatchAds, useAdsListener } from '../../services/admob';
import { format, getMonth } from 'date-fns';
import BuzzvilAd from '../../components/BuzzvilAd';
import BananaGauge from '../../components/BananaGauge.jsx';
import EggImageMain from '../../components/EggImageMain.jsx';
import { useUnityGameStatus } from '../game/yaong-egg/GameProviderEgg.jsx';
// import {BottomPopup} from "../../components/common/Popup";
// import PopupBackground from "../../assets/images/benefit_placeholder.png";

export default function PlaygroundPage() {
  const navigate = useNavigate();
  const RTE = useRunTimeEnvironment();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken, appInfo } = useContext(AuthContext);
  const accessToken = useAccessToken();

  const [friendCode, setFriendCode] = useState('');
  const [friendCodeOpen, setFriendCodeOpen] = useState(true);
  const [adKey, setAdKey] = useState();
  const [adPath, setAdPath] = useState();
  const [alertMessage, setAlertMessage] = useState(false);
  const [welcomeOpen, setWelcomeOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [stepCount, setStepCount] = useState(0);
  const [adParams, setAdParams] = useState({});
  const alertTimeout = 2500;
  const fetcher = (url) => fetch(url).then((res) => res.json());

  // const [pointPopupOpen, setPointPopupOpen] = useState(false);

  // const { data: profile } = useSWR(accessToken && [`${API_SERVER_DOMAIN}/user/profile/info`, accessToken], fetchWithToken);
  const {
    data: profile,
    isLoading: isProfileLoading,
    mutate,
  } = useSWR(accessToken && [`${API_SERVER_DOMAIN}/auth/user/check`, accessToken], fetchWithToken);
  const { data: config, isLoading: isConfigLoading } = useSWR(`${API_SERVER_DOMAIN}/auth/config`, fetcher);

  // 이번달 획득 포인트
  const { data: monthlyPoint } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}/pool/event/userMonthlyPoint`, accessToken],
    fetchWithToken,
  );

  // 토리 게임 목록
  /* const { data: activeGameRooms, isValidating } = useSWR(`${API_SERVER_DOMAIN}/game/rooms?type=active`, fetcher, {
    refreshInterval: 3000,
  });
  const { data: waitingGameRooms, isLoading: isScheduledGameLoading } = useSWR(
    `${API_SERVER_DOMAIN}/game/rooms?type=waiting`,
    fetcher,
  ); */

  // 야옹에그 정보
  const { data: eggData, mutate: mutateEggData } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}/game/egg/userGameInfo`, accessToken],
    fetchWithToken,
  );
  const { isFullyReady, showInModal, setShowInModal, setGameMode } = useUnityGameStatus();
  const [gameRoom, setGameRoom] = useState(false);

  // 첫 로그인 시 리퍼럴 입력으로 보상 신청
  const getReward = async () => {
    if (profile.refCode === friendCode) {
      alert('스스로 초대 할 수 없어요.');
      return;
    }

    const response = await fetch(`${API_SERVER_DOMAIN}/user/ref/submit`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ref_code: friendCode,
      }),
    });

    const jsonData = await response.json();
    if (jsonData.result === 'ok') {
      setAlertMessage(`소환 코드를 통해 가입하신 ${profile.userInfo.nickName}님께 200포인트가 지급 되었어요.`);
    } else {
      setAlertMessage(jsonData.message);
    }
    setFriendCodeOpen(false);

    setTimeout(() => {
      setWelcomeOpen(true);
    }, alertTimeout - 300);
  };

  // 공지사항 6월 11일 ~ 22일
  /* const showNotification = () => {
    if (isBefore(new Date(), "2024-06-22") && !localStorage.getItem("read240611")) {
      setNotificationOpen(true);
    }
  } */

  useScript(`${process.env.PUBLIC_URL}/flutter/flutter_script.js`);

  // 포인트를 위한 광고 시청
  const startAds = async (path) => {
    const response = await getPaidToWatchAds(RTE, `${API_SERVER_DOMAIN}${path}`, accessToken);
    if (response.adKey) {
      setAdKey(response.adKey);
      setAdPath(path);
    } else {
      setAlertMessage(response.message);
    }
  };

  // 토리 게임 실행
  /* const runToryGame = async (roomId) => {
    const response = await fetch(`${API_SERVER_DOMAIN}/game/start`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        roomId: roomId,
      }),
    });
    const jsonData = await response.json();

    if (jsonData.result === 'ok') {
      window.flutter_inappwebview.callHandler('goto_game', roomId);
    } else {
      setAlertMessage(jsonData.message);
    }
  }; */

  const step = async () => {
    const { step } = await window.flutter_inappwebview.callHandler('request_step');
    setStepCount(step);
  };

  // 광고 시청 보상 지급
  useAdsListener(`${API_SERVER_DOMAIN}${adPath}`, accessToken, { adKey: adKey }, mutate);

  useEffect(() => {
    let pageContainer = document.getElementsByClassName('page-container')[0];
    pageContainer?.scrollTo(0, 0);

    const getNativeInfo = async () => {
      const info = await window.flutter_inappwebview.callHandler('get_native_play');
      setAdParams({
        platform: appInfo.os.substring(0, 1).toUpperCase(),
        unitId: info.unit_id,
        ifa: info.ifa,
        ifv: info.ifv,
      });
    };
    if (RTE === 'APP') {
      getNativeInfo();
    }

    // 토리게임 종료 이벤트 수신
    /* const handleExternalChange = ({ detail }) => {
      if (detail.unityToss === 'EndRewardInside') {
        navigate('/user/coupons', {
          state: {
            nickname: profile.userInfo.nickName,
          },
        });
      } else if (detail.unityToss === 'End') {
        window.flutter_inappwebview.callHandler('show_interstitial_torry');
      }
    }; */

    function onScroll() {
      if (pageContainer.scrollTop > 160) {
        document.getElementById('playground-header').className = 'not-top';
      } else {
        document.getElementById('playground-header').className = 'top';
      }
    }

    pageContainer?.addEventListener('scroll', onScroll);
    // window.addEventListener('unityToss', handleExternalChange);

    return () => {
      pageContainer?.removeEventListener('scroll', onScroll);
      // window.removeEventListener('unityToss', handleExternalChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 오퍼월 메뉴
  const offerWallItems = [
    {
      title: '어쩌다 야옹에그',
      description: '야옹에그 부화하고 선물 받기',
      btnIcon: EggIcon,
      iconWidth: 30,
      btnText: '이동하기',
      onClickEvent: () => {
        if (isFullyReady) {
          setGameMode('');
          setShowInModal(true);
        }
      },
    },
    {
      title: '매일매일 야옹출석',
      description: '연속 출석하고 포인트 획득',
      btnIcon: AttendanceIcon,
      iconWidth: 22,
      btnText: '최대 300P',
      onClickEvent: () => {
        navigate('/attendance-check');
      },
    },
    {
      title: '야옹이 럭키스핀',
      description: '야옹이가 돌려요~ 행운당첨 룰렛',
      btnIcon: LuckySpinIcon,
      iconWidth: 26,
      btnText: '돌리기',
      onClickEvent: () => {
        // alert('현재 럭키 스핀 기능에 문제가 있어 수정 중입니다. 잠시만 기다려 주세요!');
        navigate('/cat-lucky-spin');
      },
    },
    {
      title: '야옹 퀴즈/운세',
      description: '야옹 퀴즈 풀고 운세도 보고',
      btnIcon: QuizIcon,
      iconWidth: 26,
      btnText: '최대 1000P',
      onClickEvent: () => {
        if (RTE === 'APP') {
          window.flutter_inappwebview.callHandler('goto_offerwall_content');
        }
      },
    },
    {
      title: '야옹 클릭',
      description: '클릭만 해도 포인트 지급',
      btnIcon: ClickIcon,
      iconWidth: 26,
      btnText: '클릭하기',
      onClickEvent: () => {
        if (RTE === 'APP') {
          window.flutter_inappwebview.callHandler('goto_offerwall_main');
        }
      },
    },
    {
      title: '야옹 친구소환',
      description: '친구를 초대하면 포인트야옹~',
      btnIcon: SummonIcon,
      iconWidth: 28,
      btnText: '최대 1000P',
      onClickEvent: () => {
        navigate('/invite');
      },
    },
    {
      title: '야옹 쇼핑',
      description: '쇼핑하고 포인트 받기',
      btnIcon: ShoppingIcon,
      iconWidth: 26,
      btnText: '쇼핑하기',
      onClickEvent: () => {
        if (RTE === 'APP') {
          window.flutter_inappwebview.callHandler('goto_offerwall_shopping');
        }
      },
    },
  ];

  useEffect(() => {
    if (accessToken && !isProfileLoading && profile.userInfo) {
      // 계정 인증 확인
      if (!localStorage.getItem('isVerified')) {
        fetch(`${API_SERVER_DOMAIN}/auth/cert/check`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.json())
          .then((obj) => {
            if (obj.result === 'ok' && obj.cert_state === 'Y') {
              localStorage.setItem('isVerified', 'Y');
            } else {
              navigate('/verification', {
                state: { accessToken: accessToken, redirectTo: '/playground-v2' },
              });
            }
          });
      }

      // flutter한테 Authentication 핸들링 할 수 있게 전송
      if (RTE === 'APP') {
        window.flutter_inappwebview.callHandler('grantAuthInfo', accessToken, profile.userInfo.userNo);
      }
      setGameMode('login'); // 게임 모드 초기화

      if (!profile.isFirstLogin) {
        // showNotification();
        const today = format(new Date(), 'yyyy-MM-dd');
        const storedDate = localStorage.getItem('downloadPopup');
        const storedDate2 = localStorage.getItem('playgroundAdPopup');
        if (!storedDate || storedDate !== today) {
          setDownloadOpen(true);
        }
        if (!storedDate2 || storedDate2 !== today) {
          if (RTE === 'APP') {
            localStorage.setItem('playgroundAdPopup', format(new Date(), 'yyyy-MM-dd'));
            window.flutter_inappwebview.callHandler('show_interstitial_start');
          }
        }
      }
    }
  }, [accessToken, isProfileLoading]);

  // 토리게임 대기실 업데이트
  /* useEffect(() => {
    if (!isValidating && !isScheduledGameLoading) {
      const room = activeGameRooms.infos.filter((room) =>
        isBefore(constructNow(), subSeconds(room.beginRunningTime, 10)),
      );

      if (room.length === 0) {
        setGameRoom(waitingGameRooms.infos[0]);
      } else {
        setGameRoom(room[0]);
      }
    }
  }, [isValidating, isScheduledGameLoading]); */

  // 야옹에그 게임 열기/닫기 watch
  useEffect(() => {
    mutateEggData(); // 게임 데이터 재조회
  }, [showInModal]);

  useScript('https://t1.kakaocdn.net/kakao_js_sdk/2.7.1/kakao.min.js');

  if (!profile || !config) return;

  if (RTE === 'APP') {
    if (!profile.userInfo) {
      // 여러가지 세션 적용방식이 변경됨에따른, 구버전에서 오류가 발생함으로, 구버전의 경우 로그인 다시하도록 강제 redirection이 필요한상황
      localStorage.clear();
      window.location.replace('/login');
    }

    step();
  }

  return (
    <section className="playground-page">
      {/* 2025.07.14 ~ 08.10 수영장 이벤트 팝업 -- 종료 */}
      {/* <PoolEvent /> */}

      <header id="playground-header">
        <h1>야옹상회</h1>
        <div className="my-points" onClick={() => navigate('/user/points')}>
          <img src={PointImg} alt={'points'} width={24} />
          <span>{profile.userInfo.point.toLocaleString()}</span>
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path d="M1 1L5 5L1 9" stroke="white" strokeLinecap="square" />
          </svg> */}
        </div>
        <svg
          onClick={() => navigate('/notifications')}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.22678 3.22703C8.49265 1.96116 10.2095 1.25 11.9997 1.25C13.79 1.25 15.5068 1.96116 16.7727 3.22703C18.0386 4.4929 18.7497 6.20979 18.7497 8C18.7497 10.9571 19.4936 12.9344 20.2869 14.2092L20.2958 14.2235C20.6555 14.8016 20.9362 15.2528 21.1246 15.5795C21.2189 15.7431 21.301 15.8943 21.3602 16.0248C21.3898 16.09 21.4208 16.1653 21.4444 16.2446C21.4645 16.3119 21.4988 16.4441 21.4859 16.6019C21.4757 16.7273 21.4514 16.9183 21.3433 17.1129C21.2352 17.3075 21.0858 17.429 20.9848 17.5039C20.7858 17.6516 20.5508 17.6868 20.459 17.7004C20.3251 17.7202 20.1685 17.7307 20.0025 17.7371C19.6722 17.75 19.2121 17.75 18.6301 17.75H18.6109H5.3886H5.36941C4.78744 17.75 4.32732 17.75 3.99701 17.7371C3.83099 17.7307 3.67438 17.7202 3.54047 17.7004C3.44871 17.6868 3.21369 17.6516 3.01469 17.5039C2.91365 17.429 2.76426 17.3075 2.65617 17.1129C2.54809 16.9183 2.52382 16.7273 2.51357 16.6019C2.50066 16.4441 2.53503 16.3119 2.55505 16.2446C2.57867 16.1653 2.60965 16.09 2.63925 16.0248C2.69853 15.8943 2.78063 15.7431 2.87494 15.5795C3.06323 15.2528 3.3439 14.8017 3.70353 14.2238L3.71263 14.2092C4.50586 12.9344 5.24975 10.9571 5.24975 8C5.24975 6.20979 5.96091 4.4929 7.22678 3.22703ZM11.9997 2.75C10.6074 2.75 9.272 3.30312 8.28744 4.28769C7.30287 5.27226 6.74975 6.60761 6.74975 8C6.74975 11.2233 5.93457 13.4775 4.9862 15.0016C4.6492 15.5432 4.39777 15.9475 4.2241 16.2434C4.50893 16.2499 4.88935 16.25 5.3886 16.25H18.6109C19.1101 16.25 19.4906 16.2499 19.7754 16.2434C19.6017 15.9475 19.3503 15.5432 19.0133 15.0017C18.0649 13.4775 17.2497 11.2233 17.2497 8C17.2497 6.60761 16.6966 5.27225 15.7121 4.28769C14.7275 3.30312 13.3921 2.75 11.9997 2.75ZM20.2577 16.2136C20.2683 16.2105 20.2744 16.2094 20.2749 16.2096C20.2753 16.2098 20.27 16.2113 20.2577 16.2136ZM3.72461 16.2096C3.72504 16.2094 3.73118 16.2105 3.74176 16.2136C3.72947 16.2113 3.72418 16.2098 3.72461 16.2096ZM8.79162 20.5037C9.06572 20.1931 9.53967 20.1636 9.85022 20.4377C10.4236 20.9438 11.175 21.25 11.9997 21.25C12.8245 21.25 13.5759 20.9438 14.1493 20.4377C14.4598 20.1636 14.9338 20.1931 15.2079 20.5037C15.482 20.8143 15.4524 21.2882 15.1419 21.5623C14.305 22.301 13.2039 22.75 11.9997 22.75C10.7956 22.75 9.69451 22.301 8.85762 21.5623C8.54707 21.2882 8.51752 20.8143 8.79162 20.5037Z"
            fill="#222222"
          />
          {/* <rect x="10" y="-2" width="12" height="12" fill="#FFFFFF" visibility={profile.showRedDot ? "visible" : "hidden"} /> */}
          <rect
            x="12"
            width="8"
            height="8"
            rx="4"
            fill="#F6475F"
            visibility={profile.showRedDot ? 'visible' : 'hidden'}
          />
        </svg>
      </header>

      <div className="top-placeholder" />

      {/* 메인 상단 */}
      <div className="banner">
        <p>
          {getMonth(new Date()) + 1}월동안
          <br />
          <span>{monthlyPoint?.infos?.point.toLocaleString() ?? '0'}P</span> 모으고 있어요!
        </p>
        {/* 4) 야옹앨범 위치이동 07.14 */}
        <div className="mini-icon">
          <div className="icon-box-container icon-box-left">
            <div className="icon-box">
              <img
                src={IconMini1}
                alt="album-left-icon"
                width={42}
                height={42}
                onClick={() => {
                  setGameMode('merge');
                  setShowInModal(true);
                }}
              />
              <span>합성</span>
            </div>
            <div className="icon-box">
              <img
                src={IconMini2}
                alt="album-left-icon"
                width={42}
                height={42}
                onClick={() => {
                  setGameMode('album');
                  setShowInModal(true);
                }}
              />
              <span>도감</span>
            </div>
            <div className="icon-box">
              <img
                src={IconMini3}
                alt="album-left-icon"
                width={42}
                height={42}
                onClick={() => {
                  setGameMode('cat');
                  setShowInModal(true);
                }}
              />
              <span>부화냥</span>
            </div>
          </div>
          <div className="icon-box-container icon-box-right">
            <div className="icon-box">
              <img
                src={IconMini4}
                alt="album-left-icon"
                width={32}
                height={42}
                onClick={() => {
                  navigate('/attendance-check');
                }}
              />
              <span>출첵</span>
            </div>
            <div className="icon-box">
              <img
                src={IconMini5}
                alt="album-left-icon"
                width={36}
                height={42}
                onClick={() => {
                  // alert('현재 럭키 스핀 기능에 문제가 있어 수정 중입니다. 잠시만 기다려 주세요!');
                  navigate('/cat-lucky-spin');
                }}
              />
              <span>스핀</span>
            </div>
            <div className="icon-box">
              <img
                src={IconMini6}
                alt="album-left-icon"
                width={39}
                height={42}
                onClick={() => {
                  window.flutter_inappwebview.callHandler('goto_offerwall_main');
                }}
              />
              <span>혜택</span>
            </div>
          </div>
        </div>
        {/* 1) 야옹이 멘트 부분 */}
        <div className="speech">
          <div className="speech-bubble">
            <p>야옹이를</p>
            <p>선택해주셔야옹~</p>
          </div>
        </div>
        {/* 2) 야옹액션 - 야옹이 이미지, 게이지, 알 */}
        <div className="action">
          <div
            style={{
              position: 'absolute',
              width: '230px',
              bottom: 36,
            }}
          >
            {/* 2-1 야옹 이미지 */}
            <div className="cat-img">
              {/* Ca1, Ca2, Ca3, Cat4 */}
              {eggData?.userEggGameInfo?.eggCatId === 'cat_30000' ? (
                <img
                  src={Cat1}
                  alt="main-cat"
                  width={160}
                  height={195}
                  onClick={() => {
                    if (isFullyReady) {
                      setGameMode('');
                      setShowInModal(true);
                    }
                  }}
                />
              ) : eggData?.userEggGameInfo?.eggCatId === 'cat_30001' ? (
                <img
                  src={Cat2}
                  alt="main-cat"
                  width={160}
                  height={195}
                  onClick={() => {
                    if (isFullyReady) {
                      setGameMode('');
                      setShowInModal(true);
                    }
                  }}
                />
              ) : eggData?.userEggGameInfo?.eggCatId === 'cat_30002' ? (
                <img
                  src={Cat3}
                  alt="main-cat"
                  width={160}
                  height={195}
                  onClick={() => {
                    if (isFullyReady) {
                      setGameMode('');
                      setShowInModal(true);
                    }
                  }}
                />
              ) : eggData?.userEggGameInfo?.eggCatId === 'cat_30003' ? (
                <img
                  src={Cat4}
                  alt="main-cat"
                  width={160}
                  height={195}
                  onClick={() => {
                    if (isFullyReady) {
                      setGameMode('');
                      setShowInModal(true);
                    }
                  }}
                />
              ) : (
                <img
                  src={CatEmpty}
                  alt="main-cat"
                  width={160}
                  height={195}
                  onClick={() => {
                    if (isFullyReady) {
                      setGameMode('cat');
                      setShowInModal(true);
                    }
                  }}
                />
              )}
            </div>
            {/* 2-2) 게이지 */}
            {/* empty는 안보임처리 */}
            <BananaGauge rate={Math.floor((eggData?.userEggGameInfo?.ratio ?? 0) * 100)} />
            {/* 2-3) 에그 */}
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', bottom: 0, left: 50, zIndex: 3 }}>
                <EggImageMain eggId={eggData?.userEggGameInfo?.eggId ?? ''} />
              </div>
            </div>
          </div>
          {/* 3) 야옹이 액션 라벨 */}
          <div
            className={`button ${eggData?.userEggGameInfo?.ratio >= 1 ? 'complete' : ''}`}
            onClick={() => {
              if (isFullyReady) {
                if (eggData?.userEggGameInfo?.eggCatId == '') {
                  setGameMode('cat');
                } else {
                  setGameMode('');
                }

                setShowInModal(true);
              }
            }}
          >
            {eggData?.userEggGameInfo?.eggCatId === ''
              ? '에그 받기'
              : eggData?.userEggGameInfo?.ratio < 1
                ? '간식 주러 가기'
                : '선물 받기'}
            <img src={ArrowRightBanner} alt="comment-button" width={16} height={16} />
          </div>
        </div>
        {/* 4) 야옹앨범 부분 */}
        {/* <div className="mini-icon">
          <div className="icon-box">
            <img
              src={IconMini1}
              alt="album-left-icon"
              width={31}
              height={31}
              onClick={() => {
                if (isFullyReady) {
                  setGameMode('merge');
                  setShowInModal(true);
                }
              }}
            />
            <span>합성</span>
          </div>
          <div className="icon-box">
            <img
              src={IconMini2}
              alt="album-left-icon"
              width={31}
              height={31}
              onClick={() => {
                setGameMode('album');
                setShowInModal(true);
              }}
            />
            <span>도감</span>
          </div>
          <div className="icon-box">
            <img
              src={IconMini3}
              alt="album-left-icon"
              width={31}
              height={31}
              onClick={() => {
                setGameMode('cat');
                setShowInModal(true);
              }}
            />
            <span>부화냥</span>
          </div>
        </div> */}
      </div>

      <article>
        {/* 내가 모은 간식 */}
        <div className="mini-games">
          <div className="snack-container">
            <div className="row">
              <div className="title">내가 모은 간식</div>
              <div className="row-link" onClick={() => navigate('/game/yaong-egg/snack')}>
                <img src={IconSnack} alt="icon-snack" width={18.06} height={15} />
                <div className="cnt">{eggData?.userEggGameInfo?.snackCount ?? 0}</div>
                <img src={IconSnackArrow} alt="icon-snack" width={14} height={11} />
              </div>
            </div>
            <div
              className="snack-btn-box"
              onClick={() => {
                if (isFullyReady) {
                  setGameMode('shop');
                  setShowInModal(true);
                }
              }}
            >
              <div className="snack-btn">
                <img src={IconSnackBtn} alt="icon-snack" width={19} height={22} />
                <span>간식 충전소</span>
              </div>
            </div>
          </div>
        </div>
        {/* 기획 잘못 이해하고 작업 */}
        {/* 야옹이를 부탁해 */}
        {/* <div className='mini-games'>
          <div>
            <h2>야옹이를 부탁해</h2>
          </div>
          <p className='text-extra-light game-text'>야옹이를 잘 키우면 선물을 물어다 줘요!</p>
          <div className='take-care-cat'>
            <div className='item-box'>
              <div className='left-box'>
                <span>선택한 상품</span>
                <div className='item-info'>
                  <p>[교촌치킨] 허니 오리지널+레드 오리지널 + ㅁ나ㅓ림ㄴ어림낭ㄹ</p>
                  <p className='sec-p'>활동지수가지 30.0%</p>
                </div>
              </div>
              <div className='item-img'>
                <img src={ItemImgBox} class='background-img' alt='itemBox' width={72} height={78.83} />
                <img src={SampleItemImg} class='foreground-img' alt='itemBox' width={68} height={68} />
              </div>
            </div>
            <div className='progress'>
              <div class='progress-container'>
                <div
                  class='progress-bar'
                  style={{
                    width: '30%',
                  }}
                ></div>
              </div>
            </div>
            <div>
              <Button onClick={() => alert('야옹이 합성')}>야옹이 합성</Button>
              <Button onClick={() => navigate('/game/yaong-egg')}>키우러 가기</Button>
            </div>
          </div>
        </div> */}
        {/* 토리를 구해줘 */}
        {/* <div className="mini-games">
          <div>
            <h2>토리를 구해줘</h2>
            <span onClick={() => navigate('/tory-game')}>게임방 전체 보기</span>
            <ArrowRight height={15} onClick={() => navigate('/tory-game')} />
          </div>
          <p className="text-extra-light game-text">토리를 구하고 상품을 가져가세요.</p>
          <div className="next-game">
            {gameRoom && (
              <>
                <img src={JSON.parse(gameRoom.goodsInfo).IMG_URL} alt="game-img" height={80} width={80} />
                <div>
                  {differenceInSeconds(gameRoom.beginRunningTime, constructNow()) > 60 && (
                    <div>
                      <span className="before-start-tag">
                        {getHours(gameRoom.beginRunningTime) < 12 ? '오전' : '오후'}{' '}
                        {getHours(gameRoom.beginRunningTime) > 12
                          ? getHours(gameRoom.beginRunningTime) - 12
                          : getHours(gameRoom.beginRunningTime)}
                        :
                        {getMinutes(subMinutes(gameRoom.beginRunningTime, 1)) < 10
                          ? '0' + getMinutes(subMinutes(gameRoom.beginRunningTime, 1))
                          : getMinutes(subMinutes(gameRoom.beginRunningTime, 1))}{' '}
                        오픈 예정
                      </span>
                      <span>참가비 {gameRoom.entryFee.toLocaleString()}P</span>
                    </div>
                  )}
                  {differenceInSeconds(gameRoom.beginRunningTime, constructNow()) < 60 && (
                    <div>
                      <span>진행중</span>
                      <span>참가비 {gameRoom.entryFee.toLocaleString()}P</span>
                    </div>
                  )}

                  <p className="text-grey">{JSON.parse(gameRoom.goodsInfo).GOODS_NAME}</p>
                </div>
              </>
            )}
          </div>
          <div className="next-game-btn">
            <Button onClick={() => navigate('/playground-v2/store')}>광고 보고 아이템 얻기</Button>
            <Button
              disabled={!gameRoom || !(differenceInSeconds(gameRoom.beginRunningTime, constructNow()) < 60)}
              onClick={() => {
                if (RTE === 'APP') {
                  runToryGame(gameRoom.roomId);
                } else {
                  setAlertMessage('게임은 앱에서만 가능해요');
                }
              }}
            >
              바로 진입하기
            </Button>
          </div>
        </div> */}

        {/* 야옹배너 */}
        <div className="ad-banner" onClick={() => startAds('/gate/ad/point')}>
          <span>야옹이의 혜택</span>
          <p>
            클릭하고 야옹이가 주는
            <br />
            2포인트를 받아가세요!
          </p>
          <img src={BenefitsCatImg} alt="혜택" width={107} />
        </div>
        {adParams.unitId && <BuzzvilAd adParams={adParams} extraStyle="buzzilad-container-playground" />}

        <hr />

        <ul className="offer-wall">
          {offerWallItems.map((menuItem) => (
            <li key={menuItem.title} onClick={menuItem.onClickEvent}>
              <div>
                <img src={menuItem.btnIcon} alt="star-icon" width={menuItem.iconWidth} />
              </div>
              <div>
                <h4>{menuItem.title}</h4>
                <p className="text-grey">{menuItem.description}</p>
              </div>
              <Button>{menuItem.btnText}</Button>
            </li>
          ))}
        </ul>
      </article>

      <ToastAlert show={!!alertMessage} onClose={setAlertMessage} text={alertMessage} timeout={alertTimeout} />
      {/* "시청 횟수를 초과하여 더 이상 광고 시청을 할 수 없어요. 내일 다시 시청해 주세요." */}
      <ModalDialog
        title={'나를 소환한 친구 코드'}
        className="friend-code-modal"
        open={profile.isFirstLogin && friendCodeOpen}
        onCancel={() => setFriendCodeOpen(false)}
      >
        <TextField onChange={setFriendCode} defaultValue="" />
        <p className="text-light">초대받은 후 1달 내 회원탈퇴를 하시면 초대로 받으신 포인트가 모두 사라져요.</p>
        <div className="friend-nickname">
          <span>부여받은 닉네임</span>
          <span className="text-accent">{profile.userInfo.nickName}</span>
        </div>
        <Button onClick={() => getReward()}>확인</Button>
      </ModalDialog>

      <ModalDialog title="가입을 축하합니다!" className="welcome-modal" open={welcomeOpen}>
        <p className="text-light">
          가입 선물로 <strong>300p</strong>
          <br />
          드려요!!
        </p>
        <img src={PointImg} width={124} role="presentation" />
        <Button
          onClick={() => {
            setWelcomeOpen(false);
            // showNotification();
          }}
        >
          확인
        </Button>
      </ModalDialog>

      <AlertDialog
        open={notificationOpen}
        className="notification-modal"
        title="공지 사항"
        onClose={() => setNotificationOpen(false)}
        onCancel={() => {
          localStorage.setItem('read240611', true);
          setNotificationOpen(false);
        }}
        onOk={() => {
          localStorage.setItem('read240611', true);
          setNotificationOpen(false);
        }}
        buttonText="확인"
        buttonSecondText="다시 보지 않기"
        text={
          '안녕하세요.야옹상회 회원여러분\n\n불법 프로그램 등을 이용한 회원 추천 시, 추천인 포인트가 취소되거나 지급되지 않을 수 있습니다.\n야옹상회는 공정한 서비스 운영을 위해 최선을 다하겠습니다'
        }
      />

      {/* {RTE === "WEB" && ( */}
      {1 === 2 && (
        <ModalDialog className="popup-download-modal" open={downloadOpen}>
          <img src={AppStorePopup} alt="앱 다운로드 안내" />
          <div
            className="close"
            onClick={() => {
              setDownloadOpen(false);
            }}
          >
            <img src={ClosePopup} alt="팝업 닫기" />
          </div>
          <div className="buttons">
            <div className="btn_container">
              <a
                href="#"
                onClick={() => {
                  localStorage.setItem('downloadPopup', format(new Date(), 'yyyy-MM-dd'));
                  window.location.href = 'https://play.google.com/store/apps/details?id=com.yaong.app';
                }}
              >
                <GooglePlayLogo />
              </a>
              <a
                href="#"
                onClick={() => {
                  localStorage.setItem('downloadPopup', format(new Date(), 'yyyy-MM-dd'));
                  window.location.href =
                    'https://apps.apple.com/kr/app/%EC%95%BC%EC%98%B9%EC%83%81%ED%9A%8C-%EC%89%BD%EA%B3%A0-%EC%A6%90%EA%B1%B0%EC%9A%B4-%ED%8F%AC%EC%9D%B8%ED%8A%B8-%EB%A6%AC%EC%9B%8C%EB%93%9C%EC%95%B1-%EC%95%B1%ED%85%8C%ED%81%AC/id6502283766';
                }}
              >
                <AppleStoreLogo />
              </a>
            </div>
          </div>
        </ModalDialog>
      )}

      {/* <BottomPopup
        title="클릭하고 적립"
        open={pointPopupOpen}
        setOpen={setPointPopupOpen}
      >
        <div className="benefits-popup">
          <img src={PopupBackground} alt="popup-bg" width={"100%"}/>
          <h4>타이틀을 입력하세요</h4>
          <p className="text-grey">내용을 입력하세요</p>
          <div>
            <Button onClick={() => window.flutter_inappwebview.callHandler("goto_offerwall_main")}>포인트 더 받기</Button>
            <Button onClick={() => {
              localStorage.setItem("offerwallPopup", format(new Date(), "yyyy-MM-dd"));
              setPointPopupOpen(false);
            }}>
              오늘하루 그만보기
            </Button>
          </div>
        </div>
      </BottomPopup> */}
    </section>
  );
}
